import React from 'react';
import { Card } from '@/components/ui/card';
import { Home } from 'lucide-react';

/* eslint-disable react/prop-types */
export function PricingInsightsWidget({ pricingInsights, pricingFlaggedRows }) {
  if (!pricingInsights || pricingInsights.flagged === 0) return null;

  return (
    <Card data-testid="pricing-insights-widget" className="p-6 mb-8 border border-border shadow-sm">
      <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
        <div>
          <h2 className="text-lg font-semibold text-primary">Pricing Insights</h2>
          <p className="text-xs text-muted-foreground">
            {pricingInsights.flagged} of {pricingInsights.total}{' '}
            {pricingInsights.total === 1 ? 'listing needs' : 'listings need'} a look —
            {' '}based on comparable listings in the same city.
          </p>
        </div>
      </div>
      <ul className="divide-y divide-border/60" data-testid="pricing-insights-list">
        {pricingFlaggedRows.map((p) => {
          const isUnder = p.verdict === 'underpriced';
          return (
            <li key={p.property_id} data-testid={`pricing-row-${p.property_id}`} className="py-3 flex items-center gap-4">
              <div className="w-14 h-14 flex-shrink-0 rounded-lg overflow-hidden bg-muted">
                {p.image ? (
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center"><Home className="w-6 h-6 text-muted-foreground" /></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{p.title}</div>
                <div className="text-xs text-muted-foreground truncate">
                  Your price ${p.price.toLocaleString()} · comparable median {p.median_comp_price != null ? `$${p.median_comp_price.toLocaleString()}` : '—'} ({p.comp_count} comps)
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <span
                  data-testid={`pricing-verdict-${p.property_id}`}
                  className={`inline-block text-[11px] px-3 py-1 rounded-full font-semibold uppercase tracking-wide ${
                    isUnder
                      ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                      : 'bg-amber-50 text-amber-700 border border-amber-200'
                  }`}
                >
                  {isUnder ? '↑ Room to raise' : '↓ Above market'}
                </span>
                <div className={`text-xs font-semibold tabular-nums mt-1 ${isUnder ? 'text-emerald-700' : 'text-amber-700'}`}>
                  {p.pct_diff > 0 ? '+' : ''}{p.pct_diff}%
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
/* eslint-enable react/prop-types */
